import React from 'react';
import styled, { css } from 'styled-components';
import { Classable, HasChildren, Shapeable, Slice } from '@shapeable/types';
import { breakpoints, theme, ColorTokens } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { EntityStack, useActiveEntity, useLink, usePageEntity } from '@shapeable/ui';
import { Region } from '@shapeable/kelp-forest-alliance-types';
import { ChevronRightIconGlyph } from '@shapeable/icons';

const cls = classNames('slice-entity-stack');

// -------- Types -------->

// -------- Props -------->

export type SliceEntityStackLinkProps = Classable & HasChildren & { 
  entity?: Slice;
};

export const SliceEntityStackLinkDefaultProps: Omit<SliceEntityStackLinkProps, 'entity'> = {
};

// -------- Child Component Props -------->

type ContainerProps = {

};

// -------- Styles -------->

const ContainerStyles = breakpoints({
  base: css`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: ${theme.UNIT(5)};

    &:hover {
      ${cls.child('icon-right-arrow')} {
        transform: translateX(6px);
      }
    }

  `,
});

const PeopleStackStyles = breakpoints({
  base: css`
    
  `,
});

const IconRightArrowStyles = breakpoints({
  base: css`
    transition: ${theme.TRANSITION('transform')};
  `,
});


// -------- Components -------->

const My = {
  Container: styled.div<ContainerProps>`${ContainerStyles}`,
    PeopleStack: styled(EntityStack)`${PeopleStackStyles}`,
    IconRightArrow: styled(ChevronRightIconGlyph).attrs(cls.attr('icon-right-arrow'))`${IconRightArrowStyles}`,
};

export const SliceEntityStackLink: Shapeable.FC<SliceEntityStackLinkProps> = (props) => {
  const { className, children, entity } = props;

  const { link } = entity || {};
  const hasUrl = !!link?.url;
  
  const activeEntity = usePageEntity() as Region;
  const { authors = [] } = activeEntity;

  const { Link } = useLink();

  if (!authors.length) {
    return null;
  }

  return (
    <Link href={hasUrl ? link.url : '#'} style={{ textDecoration: 'none' }}>
      <My.Container className={cls.name(className)}>
        <My.PeopleStack items={activeEntity.authors} />
        <My.IconRightArrow size={16} colors={{ fill: "line" }} />
      </My.Container>
    </Link>
  )
};

SliceEntityStackLink.cls = cls;